import {useMutation, useQuery} from "react-query";
import {postApi} from "../../fetch-api/post";
import {putApi} from "../../fetch-api/put";
import {useQueryContext} from "../../../contexts/query";
import {filterFetch, normalFetch} from "../../fetch-api/get";
import {useMainContext} from "../../../contexts/main";
import {makeQueryFilters} from "../../../utils/query-maker";
import {deleteApi} from "../../fetch-api/delete";


const MULTI_SIGNATURE_KEYS = {
    FETCH_MULTI_SIGNATURES: 'fetch-multi-signatures',
    GET_A_MULTI_SIGNATURE: 'get-a-multi-signature',
    CREATE_MULTI_SIGNATURE: 'create-multi-signature',
    UPLOAD_MULTI_SIGNATURE_IMAGE: 'upload-multi-signature-image',
    UPDATE_MULTI_SIGNATURE: 'update-multi-signature',
    DELETE_MULTI_SIGNATURE: 'delete-multi-signature'
}


const useGetAllMultiSignatures = (filters, pagination) => {

    const { lang } = useMainContext()
    const params = {...makeQueryFilters(filters, lang), ...pagination}

    return useQuery(
        MULTI_SIGNATURE_KEYS.FETCH_MULTI_SIGNATURES, () => filterFetch(params, 'multiSignatures')
    )
}


const useGetAMultiSignature = (id) => {

    return useQuery(
        MULTI_SIGNATURE_KEYS.GET_A_MULTI_SIGNATURE, () => normalFetch(`multiSignatures/${id}`),
        {
            select: res => res?.data?.data
        }
    )
}


const useCreateMultiSignature = () => {

    const { setToast } = useQueryContext()

    return useMutation(
        MULTI_SIGNATURE_KEYS.CREATE_MULTI_SIGNATURE, (data) => postApi(data, 'multiSignatures'),
        {
            onSuccess: () => {
                setToast({
                    show: true,
                    message: 'operation-success'
                })
            }
        }
    )
}


const useUpdateMultiSignature = () => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        MULTI_SIGNATURE_KEYS.UPDATE_MULTI_SIGNATURE, (payload) => putApi(payload.data, `multiSignatures/${payload.id}`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(MULTI_SIGNATURE_KEYS.FETCH_MULTI_SIGNATURES)
                setToast({
                    message: 'operation-success',
                    show: true
                })
            }
        }
    )
}

const useDeleteMultiSignature = () => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        MULTI_SIGNATURE_KEYS.DELETE_MULTI_SIGNATURE, (id) => deleteApi(`multiSignatures/${id}`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(MULTI_SIGNATURE_KEYS.FETCH_MULTI_SIGNATURES)
                setToast({
                    message: 'operation-success',
                    show: true
                })
            }
        }
    )
}


const useUploadMultiSignatureImages = () => {

    return useMutation(
        MULTI_SIGNATURE_KEYS.UPLOAD_MULTI_SIGNATURE_IMAGE, (data) => postApi(data, 'multiSignatures/upload')
    )
}





export {
    useGetAllMultiSignatures,
    useCreateMultiSignature,
    useUpdateMultiSignature,
    useUploadMultiSignatureImages,
    useDeleteMultiSignature,
    useGetAMultiSignature
}
